import { CORE_PREFILL_STORE } from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const prefillStore = props => (dispatch) => {
    dispatch({
        type: CORE_PREFILL_STORE,
        payload: props
    });
};
